module.exports = __webpack_public_path__ + "static/media/red.0b90d2f0.png";